export enum ModalType {
  GROUP_CLOSE = 'GROUP_CLOSE',
  GROUP_CHANGE_FOUNDER = 'GROUP_CHANGE_FOUNDER',
  INVITE_TO_GROUP = 'INVITE_TO_GROUP',
  REPORT_PROFILE = 'REPORT_PROFILE',
  ACCOUNT_REACTIVATED = 'ACCOUNT_REACTIVATED',
}
